import { UserCountryCode } from '@shared/types/countryCodes.ts';
import { CountryAssetKey, CountryAssetKeys, resolveCountryAssetKey } from '@shared/utils/resolveCountryAssetKey.ts';

const themeLoaders: Record<CountryAssetKey, () => Promise<unknown>> = {
  [CountryAssetKeys.DEFAULT]: () => import('@appTheme/theme.scss'),
  [CountryAssetKeys.DE]: () => import('@appTheme/theme-de.scss'),
};

let loadedThemeKey: CountryAssetKey | null = null;

export async function loadCountryTheme(countryCode: UserCountryCode | null): Promise<void> {
  const themeKey = resolveCountryAssetKey(countryCode);

  if (loadedThemeKey === themeKey) {
    return;
  }

  await themeLoaders[themeKey]();
  loadedThemeKey = themeKey;
}

export function resetLoadedCountryThemeForTesting(): void {
  loadedThemeKey = null;
}

export function getLoadedCountryThemeKeyForTesting(): CountryAssetKey | null {
  return loadedThemeKey;
}
